<template>
  <div id="index" class="index" v-if="!isInBlack">
    <div class="index-header">
      <img src="~/assets/images/logo_new.png" alt="" class="index-icon">
    </div>
    <span class="index-download" @click="sloganClick">{{slogan}}<span class="index-download-tip">{{downloadTip}}<span class="index-download-right"></span></span></span>
    <div class="index-main" v-if="show.iosShow && !show.maskShow || show.androidShow && !show.maskShow">
      <div class="index-logo">
        <div class="index-img" v-if="groupInfo.imgSrc">
          <img :src="groupInfo.imgSrc" @load="loadedGoupLogo" @error="loadedErrorLogo" class="index-img" v-show="showLogo" />
          <span class="index-font" v-show="!showLogo">{{groupInfo.groupName.substr(0,1)}}</span>
        </div>
        <div  class="index-title">
          <img v-if="groupInfo.groupName" :src="groupInfo.groupNameImg">
        </div>
        <!-- <h5 class="index-title" v-if="groupInfo.groupName" v-html="groupInfo.groupName"></h5> -->
        <p class="index-extrainfo" v-if="groupInfo.extraInfo" v-html="groupInfo.extraInfo"></p>
        <p class="index-extrainfo" v-if="groupInfo.descNoInfo" v-html="groupInfo.descNoInfo"></p>
      </div>
      <div class="index-buttons" :class="{show: show.iosShow && !show.maskShow}"  @mouseover="iosQrHandler" @mouseout="iosQrHandler">
        <a href="javascript:;" class="index-btn" @click="joinGroup" v-if="ifMobile">{{btnText}}</a>
        <div class="qrcode-ios" :class="{'qrcode-ios-show':show.iosQrShow && !ifMobile}" v-if="!ifMobile">
          <qr-code :val="qrCodeVal" :size="qrCodeSize" class="qrcode-img"></qr-code>
        </div>
      </div>
      <div class="index-buttons" :class="{show: show.androidShow && !show.maskShow}" @mouseover="show.androidQrShow=true" @mouseout="show.androidQrShow=false">
        <a href="javascript:;" class="index-btn" @click="downloadAndroidConfirm">{{btnText}}</a>
        <!-- downloadAndroid -->
        <div class="qrcode-android" v-show="show.androidQrShow && !ifMobile">
          <qr-code :val="qrCodeVal" :size="qrCodeSize" class="qrcode-img"></qr-code>
        </div>
      </div>
      <!-- <p class="index-extrainfo" style="margin-top: .2rem;" v-if="groupInfo.desc" v-html="groupInfo.desc"></p> -->
       <div  class="index-title">
      <img class="index-extrainfo" style="margin-top: .2rem;" v-if="groupInfo.desc" :src="groupInfo.descImg">
      </div>
    </div>
    <div class="index-mask" v-if="show.maskShow || show.maskDownloadAndroid">
      <div class="load"></div>
    </div>
    <!-- android mask -->
    <div class="index-alert" :class="{show: show.androidAlertShow}" @click="show.androidAlertShow=false">
      <div class="index-arrow"></div>
      <div class="index-alert-main">
        <p class="index-info">1、点击右上角 "···"</p>
        <p class="index-info">2、选择 "在浏览器中打开"</p>
      </div>
    </div>
    <!-- ios -->
    <div class="index-alert" :class="{show: show.iosAlertShow}" @click="show.iosAlertShow=false">
      <div class="index-arrow"></div>
      <div class="index-alert-main">
        <p class="index-info">1、点击右上角 "···"</p>
        <p class="index-info">2、选择 "在Safari浏览器中打开"</p>
      </div>
    </div>
    <div class="ios-popup" :class="{'popup-show':show.iosConfirmShow}">
      <div class="popup-mask" @click="show.iosConfirmShow=false"></div>
      <div class="popup-box">
        <p class="popup-content">点击安装后APP会自动下载，<br />请返回桌面查看。</p>
        <div class="flex-box flex-item-around flex-item-align-center">
          <span class="popup-btn" @click="downloadIOS('click')">知道了</span>
          <span class="popup-btn" @click="show.iosConfirmShow=false" style="background-color: #c0c0c0;">取消</span>
        </div>
      </div>
    </div>
    <div class="ios-popup" :class="{'popup-show':show.androidConfirmShow}">
      <div class="popup-mask" @click="show.androidConfirmShow=false"></div>
      <div class="popup-box">
        <!-- <p class="popup-content">您还没有安装BiYong，请先下载。</p> -->
        <p class="popup-content">{{tips}}</p>
        <div class="flex-box flex-item-around flex-item-align-center">
          <span class="popup-btn" @click="downloadAndroidNow('click')">{{iKnowBtn}}</span>
          <span class="popup-btn" @click="show.androidConfirmShow=false" style="background-color: #c0c0c0;">{{cancelBtn}}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import MyMixin from "~/components/MainPageMixin.js";
export default {
  mixins: [MyMixin],
}
</script>



// WEBPACK FOOTER //
// pages/_id.vue